module.exports = __webpack_public_path__ + "@/assets/img/bannerReferido.bab3544d.gif";